import React, { useCallback, useEffect, useState } from 'react'
import TableRowCommon from '../../../../components/table/TableRowCommon';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import InputTextField from '../../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import { ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import { routeName } from '../../../../routes/routeName';
import TableCustom from '../../../../components/table/tableCustom';
import { dateTimeToView } from '../../../../utils/date.utils';
import { useTranslation } from 'react-i18next';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { PublishOnlineCourseApi } from '../../../../api/publish-online-course/publish-online-course.api';
import { getFileExtension } from '../../../../utils/fileTypeDownload';
import saveAs from 'file-saver';

export default function Diploma() {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([{}]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [type, setType] = useState<any>('')

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '100px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ลำดับ")
        },
        {
            id: "leave_type_name",
            width: '180px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("เลขคอร์ส"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '500px',
            sortable: false,
            align: "center",
            label: t("ชื่อคอร์ส"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ประเภท"),
        },

        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '100px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            id_online_course,
            online_course_no,
            online_course_name,
            online_course_type,
            online_course_teacher,
            status_publish,
            modified,
            modified_date } =
            objData;

        const objRenderData = {
            key: id_online_course,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: online_course_no,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        online_course_name || ''
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        online_course_type || ''
                    ),
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableDownload
                            onViewClick={() => {
                                navigate(routeName.students.TakeLesson.replace(':id', id_online_course));
                            }}


                            onDownloadClick={() => {
                                // alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                //     handleDelete(id_online_course)
                                // })
                                handleDownloadFile(id_online_course)
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (type) condition = { ...condition, id_type: type };
            if (search) condition = { ...condition, keyword: search };
            if (sortBy) condition = { ...condition, sort: sortBy };

            const res = await PublishOnlineCourseApi.my_online_course_diploma(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, sortBy, search, type]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const handleDownloadFile = async (id:any) => {

        dispatch(setLoading());

        await PublishOnlineCourseApi.my_online_course_diploma_by_id(id)
            .then((res) => {
                if (res.status < 300) {
                    const response = res.data;
                    // Get the content type from the server's response headers
                    const contentType = res.headers["content-type"];

                    // Create a Blob with the content type from the response
                    const blob = new Blob([response], { type: contentType });

                    // Extract file extension based on content type
                    const fileExtension = getFileExtension(contentType || "");

                    // Generate a filename with the correct extension (you can also modify this to use a custom name)
                    const fileName = `${"diploma" + new Date().getTime()
                        }.${fileExtension}`;

                    // Save the file
                    saveAs(blob, fileName);
                }
            })
            .catch((error) => console.log(error))
            .finally(() => dispatch(unsetLoading()));
    };
    return (
        <div>
            {/* <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("MEETING_POSITION.SEARCH_POSITION")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    
                    <ButtonPrimary
                        onClick={() => {
                            navigate(routeName.cms.OnlineCourseManagementCreate);

                        }}
                        mode="add"
                        buttonName={t("เพิ่มคอร์สเรียน")}
                    />
                </article>
            </div> */}

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
        </div>
    )
}
